(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-facility-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tab-facility-video')) {
    customElements.define('tab-facility-video', class extends HTMLElement {
      connectedCallback() {
        const cover = this.querySelector('.facility-video__cover');
        if (!cover || this.initialized) return;
        this.initialized = true;
        cover.addEventListener('click', (event) => {
          event.preventDefault();
          const iframe = this.querySelector('template').content.querySelector('iframe').cloneNode(true);
          iframe.src += '?autoplay=1';
          iframe.loading = 'eager';
          this.replaceChildren(iframe);
          iframe.focus();
        }, { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-lifextra-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-lifextra-menu-toggle]');

    if (!toggle) {
      return;
    }

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-magnimore-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-magnimore-menu-toggle]');

    if (!toggle) {
      return;
    }

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-scientific-partners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scientific-partner-dialog')) {
    customElements.define('scientific-partner-dialog', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-expert-open]');
        this.trigger.addEventListener('click', () => {
          clearTimeout(this.closeTimer);
          this.dialog.showModal();
          this.dialog.scrollTop = 0;
          this.frame = requestAnimationFrame(() => {
            this.frame = requestAnimationFrame(() => this.dialog.classList.add('is-visible'));
          });
        }, options);
        this.querySelector('[data-expert-close]').addEventListener('click', () => this.dismiss(), options);
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.dismiss();
        }, options);
        this.dialog.addEventListener('pointerdown', event => {
          this.backdropStart = this.isBackdrop(event);
        }, options);
        this.dialog.addEventListener('click', event => {
          if (this.backdropStart && this.isBackdrop(event)) this.dismiss();
          this.backdropStart = false;
        }, options);
        this.dialog.addEventListener('close', () => {
          this.dialog.classList.remove('is-visible');
          if (this.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
      }
      isBackdrop(event) {
        const rect = this.dialog.getBoundingClientRect();
        return event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      }
      dismiss() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.closeTimer);
        this.dialog.classList.remove('is-visible');
        const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240;
        this.closeTimer = setTimeout(() => this.dialog.close(), delay);
      }
      disconnectedCallback() {
        this.controller.abort();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.closeTimer);
        this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
